
function swymCallbackFn(swat){
    document.addEventListener("swym-button:loaded", function(){
    console.log("Collections loaded");
      setTimeout( () => { 
      swat.initializeActionButtons("body");
      },1500);
    })
  }
  if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);
  //console.log(_swat, '_swat');